export default "__VITE_ASSET__CKOkDeHL__"